<dc-app-landing-heading></dc-app-landing-heading>

<dc-slider-icons></dc-slider-icons>
<dc-app-landing-feature-cards></dc-app-landing-feature-cards>
<dc-app-landing-twin-phone-right-list></dc-app-landing-twin-phone-right-list>
<dc-app-landing-twin-phone-left-list></dc-app-landing-twin-phone-left-list>
<dc-counter1></dc-counter1>
<dc-screenshots-app></dc-screenshots-app>
<dc-testimonial-simple-slider></dc-testimonial-simple-slider>
<dc-app-landing-download></dc-app-landing-download>

<dc-footer1></dc-footer1>
